import React from "react";
import animation from "../../../assets/img/gloji_animation.gif";

const GlojiLoader = () => {
  return <img src={animation} alt="loading..." />;
};

export default GlojiLoader;
